import { useQuery } from "@apollo/client";
import { SharingInvitationsDocument } from "../../../../../../__generated__/graphql";

export default function useCurrentOrgInvitations() {
  const { data, loading, error, refetch } = useQuery(
    SharingInvitationsDocument
  );

  return { data, loading, error, refetch };
}
